const platform = {
    title: 'Plattformeinstellungen',
    subtitle: 'Mandantenübergreifende Administratoren und das globale Erscheinungsbild verwalten.',
    branding_title: 'Plattformmarke',
    branding_description: 'Gilt für Konsole, Anmeldung, Kontocenter, Demos und Hilfe-Center.',
    product_name: 'Produktname',
    slogan: 'Slogan',
    light_logo: 'Logo für helles Design',
    dark_logo: 'Logo für dunkles Design',
    upload_logo: 'Logo hochladen',
    uploading: 'Wird hochgeladen…',
    logo_uploaded: 'Logo hochgeladen',
    hide_open_source_notice: 'Open-Source-Hinweis ausblenden',
    hide_open_source_notice_description: 'Sichtbare Zuordnungslinks ausblenden; Lizenz- und Quelldateien bleiben erhalten.',
    save: 'Änderungen speichern',
    saving: 'Wird gespeichert…',
    saved: 'Plattformmarke gespeichert',
    administrators_title: 'Plattformadministratoren',
    administrators_description: 'Plattformadministratoren verwalten alle Mandanten und Instanzeinstellungen.',
    administrator_identifier_placeholder: 'Benutzer-ID, Benutzername oder E-Mail',
    add_administrator: 'Administrator hinzufügen',
    administrator_added: 'Plattformadministrator hinzugefügt',
    remove_administrator: 'Plattformadministrator entfernen',
};
export default Object.freeze(platform);
